import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "content-shape container pt-4"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("You don't see all the web.");

var _hoisted_3 = {
  class: "content-shape container pt-4"
};
import Showcase from "@/components/Showcase.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_n_h1 = _resolveComponent("n-h1");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_n_h1, {
        class: "text-center mb-0"
      }, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createVNode(Showcase)])]);
    };
  }
});